import { navigate, useLocation } from '@cedarjs/router'
import { COMMENT_HASH_REGEX } from '@wingwork/common/src/constants/comments'

export default function (
  defaultTab?: string
): [
  string,
  (event: React.ChangeEvent<HTMLInputElement>, value: string) => void
] {
  const { hash } = useLocation()
  const [tab, setTab] = React.useState<string>(defaultTab)

  React.useEffect(() => {
    if (hash && !hash.match(COMMENT_HASH_REGEX)) {
      const hashValue = hash.slice(1)
      setTab(hashValue)
    }
  }, [hash])

  const handleTabSwitching = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    navigate(`#${value}`, { replace: true })
  }

  return [tab, handleTabSwitching]
}
